<template>

    <button @click='likeDislike' :class=" ['fav-btn', listing ? '' : 'btn btn-primary' ]">

        <span :class="['icon icon-bookmark1', liked ? 'red' : '' ]" :title="[ liked ? 'Remove from favorites' : 'Add to favorites' ]"
                         data-toggle="tooltip" data-placement="top"></span>

        <span v-if='!liked' :class=" ['fav-txt ml-2', listing ? 'd-none' : '' ]">Add to favorites</span>
        <span v-if='liked' :class=" ['fav-txt ml-2', listing ? 'd-none' : '' ]">Remove form favorites</span>

        <span v-if='listing' class="likes"> {{ likes }} </span>

    </button>

</template>

<script>
    export default {

        mounted() {

        },

        created() {

            if( typeof this.m != 'undefined' && this.user ) {
                var modelID = parseInt( this.m );
                
                if( this.user.favs.includes( modelID ) ) {
                    this.liked = true;
                }

            }

            if( typeof this.l != 'undefined' ) {
                this.likes = parseInt( this.l );
            }

            if ( this.p == 'listing' ) {
                this.listing  = true;
            }

        },

        props : ['m','l','p'], 

        data() {

            return {
                
                disabled : false,
                liked    : false,
                likes    : 0,
                listing  : false,

            }

        },

        methods : {

            likeDislike() {
                if( !this.user ) {
                    location.href = '/login';
                }

                if( this.isLoading ) {
                    return;
                }


                if( this.liked ) {
                    var s = 0;
                } else {
                    var s = 1;
                }

                this.liked = !this.liked;
                
                this.isLoading = true;

                this._ldl( s );
            },

            _ldl : _.debounce( function( s ) {

                var me = this;

                me.ajax.call('tool:ldl', { m : this.m, s : s }, (r) => {

                    if( r.status == 'success' ) {

                        me.likes = r.data;
                        me.isLoading = false;

                        me.$emit('update', me.w, me.liked);
                    }

                });

            },500),

        }

    }
</script>
